export default __webpack_public_path__ + "static/media/pbanner_old.17524272.gif";